import React from "react";
import Card from "@mui/material/Card";
import { CardHeader, Icon } from "@mui/material";
import MDBox from "components/MDBox";
import { LanguageContext } from "App";
import { useContext } from "react";
import MDTypography from "components/MDTypography";
import SearchStringOrIntReq from "../../../../Classes/Models/Requests/SearchStringOrIntReq";
import AccountingApi from "../../../../Classes/API/AccountingApi";
import Swal from "sweetalert2";
import MDButton from "components/MDButton";
const PackageStatistics = ({ Package }) => {
  const { translations } = useContext(LanguageContext);
  const ExportReport = async () => {
    try {
      Swal.fire({
        title: "Exporting",
        text: "Please wait while we export the report",
        icon: "info",
        allowOutsideClick: false,
        showConfirmButton: false,
        didOpen: async () => {
          Swal.showLoading();
        },
      });

      let req = new SearchStringOrIntReq();
      req.SearchInt = Package.id;

      let res = await AccountingApi.ExportPackageReport(req);

      if (res.type === "application/json") {
        // Handle case when the response is JSON (likely an error response)
        let errorData = await res.text();
        throw new Error(errorData || "Export failed");
      }

      var csvURL = window.URL.createObjectURL(res);
      let tempLink = document.createElement("a");
      tempLink.href = csvURL;

      Swal.close();

      tempLink.setAttribute("download", "PackageReport.xlsx");
      tempLink.click();
    } catch (error) {
      console.error("Error exporting report:", error);

      Swal.fire({
        title: "Error",
        text: "Your session has expired or your token is invalid. Please log out and log back in.",
        icon: "error",
        confirmButtonText: "OK",
      });

      // Optionally, trigger a logout or redirect to the login page
      // UsersApi.Logout();
      // window.location.href = '/login';
    }
  };

  const getUnqiqueSessionsAndCount = (sessions) => {
    let uniqueSessions = [];
    sessions?.forEach((session) => {
      if (!uniqueSessions.includes(session.sessionName)) {
        uniqueSessions.push(session.sessionName);
      }
    });

    let finalArray = [];
    uniqueSessions?.forEach((sessionName) => {
      let count = sessions.filter((x) => x.sessionName == sessionName).length;
      let sessionId = sessions.filter((x) => x.sessionName == sessionName)[0].sessionId;
      finalArray.push({ Name: sessionName, Count: count, Id: sessionId });
    });

    return finalArray;
  };

  return (
    <Card sx={{ height: "100%", boxShadow: !false && "none", marginBottom: "2em" }}>
      <MDBox pt={2} px={2} display="flex" justifyContent="space-between" alignItems="center">
        <MDTypography variant="h6" fontWeight="medium">
          {translations.PackageInfoStatistics}
        </MDTypography>
        <MDButton onClick={() => ExportReport()} variant="gradient" color="success">
          &nbsp;{translations.PackageInfoExportReport}
        </MDButton>
      </MDBox>

      <MDBox
        mt={3}
        sx={{
          display: "flex",
          flexWrap: "wrap",
          padding: "5rem",
          justifyContent: "center",
          borderBottom: "1px solid #e0e0e0",
        }}
      >
        <MDBox
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "1em",
            textAlign: "center",
            borderRadius: "1em",
            padding: "1em",
            boxShadow: "0 0 10px 0 rgba(0,0,0,0.2)",
            margin: "4px",
            alignItems: "center",
          }}
        >
          <MDTypography variant="h6" sx={{ fontWeight: "bold" }}>
            {translations.PackageInfoTotalSessions}
          </MDTypography>
          <MDTypography variant="h6" sx={{ fontWeight: "bold" }}>
            {Package?.getAccountingSessions?.length}
          </MDTypography>
        </MDBox>
        <MDBox
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "1em",
            textAlign: "center",
            borderRadius: "1em",
            padding: "1em",
            boxShadow: "0 0 10px 0 rgba(0,0,0,0.2)",
            margin: "4px",
            alignItems: "center",
          }}
        >
          <MDTypography variant="h6" sx={{ fontWeight: "bold" }}>
            {translations.PackageInfoMadeAppointmen}
          </MDTypography>
          <MDTypography variant="h6" sx={{ fontWeight: "bold" }}>
            {Package?.getAccountingSessions?.filter((x) => x.appointmentTime != null).length}
          </MDTypography>
        </MDBox>
        <MDBox
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "1em",
            textAlign: "center",
            borderRadius: "1em",
            padding: "1em",
            boxShadow: "0 0 10px 0 rgba(0,0,0,0.2)",
            margin: "4px",
            alignItems: "center",
          }}
        >
          <MDTypography variant="h6" sx={{ fontWeight: "bold" }}>
            {translations.PackageInfoAdmitted}
          </MDTypography>
          <MDTypography variant="h6" sx={{ fontWeight: "bold" }}>
            {Package?.getAccountingSessions?.filter((x) => x.isAdmitted).length}
          </MDTypography>
        </MDBox>
        <MDBox
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "1em",
            textAlign: "center",
            borderRadius: "1em",
            padding: "1em",
            boxShadow: "0 0 10px 0 rgba(0,0,0,0.2)",
            margin: "4px",
            alignItems: "center",
          }}
        >
          <MDTypography variant="h6" sx={{ fontWeight: "bold" }}>
            {translations.PackageInfoExceptions}
          </MDTypography>
          <MDTypography variant="h6" sx={{ fontWeight: "bold" }}>
            {Package?.getAccountingSessions?.filter((x) => x.isException).length}
          </MDTypography>
        </MDBox>
        <MDBox
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "1em",
            textAlign: "center",
            borderRadius: "1em",
            padding: "1em",
            boxShadow: "0 0 10px 0 rgba(0,0,0,0.2)",
            margin: "4px",
            alignItems: "center",
          }}
        >
          <MDTypography variant="h6" sx={{ fontWeight: "bold" }}>
            {translations.PackageInfoAbsent}
          </MDTypography>
          <MDTypography variant="h6" sx={{ fontWeight: "bold" }}>
            {Package?.getAccountingSessions?.filter((x) => x.isAbsent).length}
          </MDTypography>
        </MDBox>
      </MDBox>
      {/* ************************************************** */}
      <MDBox sx={{ borderBottom: "1px solid #e0e0e0" }}>
        {getUnqiqueSessionsAndCount(Package?.getAccountingSessions)?.map((session, index) => {
          return (
            <>
              <div
                className="content"
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  justifyContent: "center",
                  borderBottom: "1px solid #e0e0e0",
                  padding: "2rem",
                }}
              >
                <MDBox
                  key={index}
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "1em",
                    textAlign: "center",
                    margin: "5px",
                    borderRadius: "1em",
                    padding: "1rem 0",
                    boxShadow: "0 0 10px 0 rgba(0,0,0,0.2)",
                    width: "151px",
                    alignItems: "center",
                  }}
                >
                  <MDTypography variant="h6" sx={{ fontWeight: "bold" }}>
                    {session.Name}
                  </MDTypography>

                  <MDTypography variant="h6" sx={{ fontWeight: "bold" }}>
                    {session.Count}
                  </MDTypography>
                </MDBox>
                {/* .......................... */}
                <MDBox
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "1em",
                    textAlign: "center",
                    margin: "5px",
                    borderRadius: "1em",
                    padding: "1rem",
                    boxShadow: "0 0 10px 0 rgba(0,0,0,0.2)",
                  }}
                >
                  <MDTypography variant="h6" sx={{ fontWeight: "bold" }}>
                    {translations.PackageInfoMadeAppointment}
                  </MDTypography>
                  <MDTypography variant="h6" sx={{ fontWeight: "bold" }}>
                    {
                      Package?.getAccountingSessions?.filter(
                        (item) => item.appointmentTime != null && item.sessionId == session.Id
                      ).length
                    }
                  </MDTypography>
                </MDBox>

                <MDBox
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "1em",
                    textAlign: "center",
                    margin: "5px",
                    borderRadius: "1em",
                    padding: "1em",
                    boxShadow: "0 0 10px 0 rgba(0,0,0,0.2)",
                  }}
                >
                  <MDTypography variant="h6" sx={{ fontWeight: "bold" }}>
                    {translations.PackageInfoAdmitted}
                  </MDTypography>
                  <MDTypography variant="h6" sx={{ fontWeight: "bold" }}>
                    {
                      Package?.getAccountingSessions?.filter(
                        (item) => item.isAdmitted && item.sessionId == session.Id
                      ).length
                    }
                  </MDTypography>
                </MDBox>
                <MDBox
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "1em",
                    textAlign: "center",
                    margin: "5px",
                    borderRadius: "1em",
                    padding: "1em",
                    boxShadow: "0 0 10px 0 rgba(0,0,0,0.2)",
                  }}
                >
                  <MDTypography variant="h6" sx={{ fontWeight: "bold" }}>
                    {translations.PackageInfoExceptions}
                  </MDTypography>
                  <MDTypography variant="h6" sx={{ fontWeight: "bold" }}>
                    {
                      Package?.getAccountingSessions?.filter(
                        (item) => item.isException && item.sessionId == session.Id
                      ).length
                    }
                  </MDTypography>
                </MDBox>
                <MDBox
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "1em",
                    textAlign: "center",
                    margin: "5px",
                    borderRadius: "1em",
                    padding: "1em",
                    boxShadow: "0 0 10px 0 rgba(0,0,0,0.2)",
                  }}
                >
                  <MDTypography variant="h6" sx={{ fontWeight: "bold" }}>
                    {translations.PackageInfoAbsent}
                  </MDTypography>
                  <MDTypography variant="h6" sx={{ fontWeight: "bold" }}>
                    {
                      Package?.getAccountingSessions?.filter(
                        (item) => item.isAbsent && item.sessionId == session.Id
                      ).length
                    }
                  </MDTypography>
                </MDBox>
                {/* ..................... */}
              </div>
            </>
          );
        })}
      </MDBox>
    </Card>
  );
};

export default PackageStatistics;
